export default __webpack_public_path__ + "static/media/Users.1a9a5e85.svg";